import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import paymentSagas from './payment/saga';
import deviceSagas from './device/saga';
import merchantSagas from './merchant/saga';
import menuSagas from './menu/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    paymentSagas(),
    deviceSagas(),
	 merchantSagas(),
	 menuSagas(),
  ]);
}
